import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LOGO_URL } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/dashboard");
    } catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left brand pane */}
      <div className="hidden lg:flex w-1/2 relative overflow-hidden items-center justify-center"
           style={{
             background: "linear-gradient(135deg, #0284C7 0%, #00AEEF 100%)",
           }}>
        <div className="absolute inset-0 opacity-10"
             style={{ backgroundImage: "radial-gradient(circle at 20% 20%, white 1px, transparent 1px), radial-gradient(circle at 80% 60%, white 1px, transparent 1px)", backgroundSize: "30px 30px" }}/>
        <div className="relative z-10 text-white max-w-md px-10">
          <img src={LOGO_URL} alt="Sohom" className="w-20 h-20 rounded-lg bg-white p-2 mb-6 shadow-lg" />
          <h1 className="text-4xl font-bold tracking-tight mb-3" style={{fontFamily:"'Outfit', sans-serif"}}>
            Sohom Lead Ops
          </h1>
          <p className="text-sky-50/90 text-base leading-relaxed">
            The operations cockpit for window &amp; door sales teams. Capture leads on-site, manage follow-ups, and convert opportunities — all in one place.
          </p>
          <div className="mt-12 grid grid-cols-3 gap-4 text-center">
            <div><div className="text-2xl font-bold">L-NNNNN</div><div className="text-xs uppercase tracking-wider text-sky-100/80 mt-1">Tracked</div></div>
            <div><div className="text-2xl font-bold">GPS</div><div className="text-xs uppercase tracking-wider text-sky-100/80 mt-1">Mapped</div></div>
            <div><div className="text-2xl font-bold">Field</div><div className="text-xs uppercase tracking-wider text-sky-100/80 mt-1">Ready</div></div>
          </div>
        </div>
      </div>

      {/* Right form pane */}
      <div className="flex-1 flex items-center justify-center px-6 bg-white">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-7 text-center">
            <img src={LOGO_URL} alt="Sohom" className="h-14 w-auto mx-auto" />
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-slate-900" style={{fontFamily:"'Outfit', sans-serif"}}>Welcome back</h2>
          <p className="text-sm text-slate-500 mt-1 mb-7">Sign in to access your operations dashboard</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-700 uppercase tracking-wider">Email</label>
              <input
                type="email"
                className="sohom-input mt-1.5"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-700 uppercase tracking-wider">Password</label>
              <input
                type="password"
                className="sohom-input mt-1.5"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
              />
            </div>
            {err && <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded px-3 py-2">{err}</div>}
            <button type="submit" className="sohom-btn-primary w-full justify-center" disabled={loading} data-testid="login-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-6 text-xs text-slate-400 text-center">
            Sohom Fenster Tech Pvt Ltd · {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </div>
  );
}
